module.exports = __webpack_public_path__ + "img/car-slogan-1.73bdf27b.png";